enum EntitlementEnum {
  REPORT_GENERAL_LEDGER = 'general.ledger',
  DATA_SHARING_IMPORT_EXPORT = 'data.sharing.import.export',
  PRODUCTION_YIELD_DATA = 'production.yield.data',
  ACCOUNTS_PLAYABLE = 'accounts.payable',
  GENERIC_MATERIAL_CONSUMPTION = 'generic.material.consumption',
  INVOICES = 'invoices',
  ELECTRONIC_INVOICES_XML_IMPORT = 'electronic.invoices.xml.import',
  LANDING_PAGE = 'landing.page',
  PURCHASE_ORDER_IN_OTHER_CURRENCIES = 'purchase.order.in.other.currencies',
  DASHBOARD_INVOICES = 'dashboard.invoices',
  DASHBOARD_PURCHASE_ORDER = 'dashboard.purchase.order',
  BALANCE_AI_VOICE_ACTIONS = 'balance.ai.voice.actions',
}

export default EntitlementEnum;
